import { apiUrl } from '../utils/apiBase';
import { quickBooksAuthHeaders } from '../utils/quickBooksAuth';

/**
 * Current user's QuickBooks connection for the given org (GET /api/quickbooks/status).
 */
export async function fetchQuickBooksStatus(orgId) {
  if (!orgId) return { connected: false, updated_at: null, error: '' };

  const auth = await quickBooksAuthHeaders();
  const res = await fetch(apiUrl(`/api/quickbooks/status?org_id=${encodeURIComponent(orgId)}`), {
    credentials: 'include',
    headers: { ...auth },
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }
  if (!res.ok) {
    const message =
      data.error ||
      (text && !text.startsWith('{') ? text.slice(0, 200).trim() : '') ||
      `Could not load QuickBooks status (HTTP ${res.status}). Is the API server running on port 5001?`;
    throw new Error(message);
  }
  return {
    connected: !!data.connected,
    updated_at: data.updated_at ?? null,
    error: data.error || '',
  };
}
